<template>
  <div
    class="tabs__item"
    :class="{active: mode === type}"
    @click="changeMode(type)"
  >
    {{ title }}
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Tab',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    type: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    ...mapState([
      'mode'
    ]),
  },
  methods: {
    changeMode (mode) {
      this.$localStorage.set('tabsmode', mode)
      this.$store.dispatch('changeMode', mode)
    }
  }
}
</script>
